import React from 'react';
import { UseFormReturn, FormState, useForm, FormProvider } from 'react-hook-form';
import { validationSchema } from './validationSchema';
import { FormValues, FIELD, FIELD_LABEL } from './types';
import useYupValidationResolver from 'form/yup/reactHookFormResolver';
import { Button, Heading, Text } from 'lmc-ui-library-rebrand';
import { Box, Column, Grid } from 'lmc-ui-library';
import { FormInputWrapper, TextInput } from 'form/infrastructure/reactHookForm';
import { ButtonsContainer, FormWrapper } from './SetPasswordForm.styled';

import styles from './_SetPasswordForm.module.scss';
import useRebrandContext from 'helpers/hooks/useRebrandContext';

type Props = {
  onSubmit: (formValues: FormValues) => void;
  labels: {
    password: string;
    confirmPassword: string;
    submitLabel: string;
  };
};

const SetPasswordForm: React.FC<Props> = ({ onSubmit }) => {
  const methods: UseFormReturn<FormValues> & { formState: FormState<FormValues> & { errors: any } } = useForm<
    FormValues
  >({
    mode: 'onSubmit',
    resolver: useYupValidationResolver(validationSchema()),
    defaultValues: {
      [FIELD.PASSWORD]: null,
      [FIELD.CONFIRM_PASSWORD]: null,
    },
  });

  const { handleSubmit } = methods;
  const [newUi] = useRebrandContext();

  return (
    <FormWrapper>
      <Box>
        <Box.Content className={styles.setPasswordBox}>
          <FormProvider<FormValues> {...methods}>
            <Grid cols={12}>
              <Column lg={7} md={10} sm={12} xs={12}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Heading weight="bold" mode="title">
                    Reset password
                  </Heading>

                  <Text weight="light">Please choose a secure password with:</Text>
                  <Text weight="light">- At least 12 characters</Text>
                  <Text weight="light">- At least 1 number, 1 uppercase, 1 lowercase and 1 special character</Text>
                  <Text weight="light">- Do not use common words or names</Text>

                  <FormInputWrapper
                    newUi={newUi}
                    title={FIELD_LABEL.PASSWORD}
                    name={FIELD.PASSWORD}
                    showMultipleErrors={true}>
                    <TextInput newUi={newUi} type="password" />
                  </FormInputWrapper>

                  <FormInputWrapper newUi={newUi} title={FIELD_LABEL.CONFIRM_PASSWORD} name={FIELD.CONFIRM_PASSWORD}>
                    <TextInput newUi={newUi} type="password" />
                  </FormInputWrapper>

                  <ButtonsContainer>
                    <Button borderVariant="rectangle" mode="primary" mt={4} mb={5}>
                      Reset password
                    </Button>
                  </ButtonsContainer>
                </form>
              </Column>
            </Grid>
          </FormProvider>
        </Box.Content>
      </Box>
    </FormWrapper>
  );
};

export default SetPasswordForm;
